export const data = {
  _id: '608128dd83ec4517981c66dc',
  slug: 'home',
  published_at: '2021-04-22T07:42:24.211Z',
  metadata: {
    twitterCardType: 'summary',
    _id: '60864f36c4aa78001cee5334',
    metaTitle: '24 FIX ซ่อมบ้านราคามาตรฐาน ครบทุกความต้องการด้วยช่างคุณภาพ',
    metaDescription:
      'บริการซ่อมแซมที่อยู่อาศัย ที่มีบริการให้เลือกมากกว่า 2,000 บริการ งานประปา งานไฟฟ้า งานกระเบื้อง งานหลังคาและอีกมากมาย พร้อมกับช่างฝีมือคุณภาพและราคามาตรฐาน',
    __v: 0,
    shareImage: {
      _id: '62da677475aa5e001b106213',
      name: 'hero_459442d269 (1).png',
      alternativeText: '',
      caption: '',
      hash: 'hero_459442d269_1_93912d97cc',
      ext: '.png',
      mime: 'image/png',
      size: 3240.58,
      width: 9000,
      height: 2938,
      url: 'https://d2jl6hozakvcbj.cloudfront.net/hero_459442d269_1_93912d97cc.png',
      formats: {
        thumbnail: {
          name: 'thumbnail_hero_459442d269 (1).png',
          hash: 'thumbnail_hero_459442d269_1_93912d97cc',
          ext: '.png',
          mime: 'image/png',
          width: 245,
          height: 80,
          size: 30.35,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_hero_459442d269_1_93912d97cc.png',
        },
        large: {
          name: 'large_hero_459442d269 (1).png',
          hash: 'large_hero_459442d269_1_93912d97cc',
          ext: '.png',
          mime: 'image/png',
          width: 1000,
          height: 326,
          size: 261.73,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/large_hero_459442d269_1_93912d97cc.png',
        },
        medium: {
          name: 'medium_hero_459442d269 (1).png',
          hash: 'medium_hero_459442d269_1_93912d97cc',
          ext: '.png',
          mime: 'image/png',
          width: 750,
          height: 245,
          size: 169.53,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_hero_459442d269_1_93912d97cc.png',
        },
        small: {
          name: 'small_hero_459442d269 (1).png',
          hash: 'small_hero_459442d269_1_93912d97cc',
          ext: '.png',
          mime: 'image/png',
          width: 500,
          height: 163,
          size: 91,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/small_hero_459442d269_1_93912d97cc.png',
        },
      },
      provider: 'aws-s3',
      related: [],
      createdAt: '2022-07-22T09:01:40.725Z',
      updatedAt: '2022-08-03T04:31:40.428Z',
      __v: 0,
      id: '62da677475aa5e001b106213',
    },
    id: '60864f36c4aa78001cee5334',
  },
  bannerSection: {
    _id: '608137bb3baea332542c66be',
    title: 'ทุกสิ่งในบ้าน ให้เราช่วยดูแล',
    description: 'รวดเร็ว สะดวกสบาย ได้มาตรฐาน',
    searchPlaceholder: 'ค้นหาบริการหรือปัญหาที่คุณมี เช่น กระเบื้อง พื้น ทาสี',
    button: [
      {
        _id: '633d3cac5abbcb001c862bf8',
        kind: 'ComponentLinksButtonLink',
        ref: '608137bb3baea332542c66bf',
      },
    ],
    __v: 1,
    coverImage: '608137713baea332542c66bd',
    coverImages: ['60e740dd75c7ab001bb5ec56', '60e7412975c7ab001bb5ec76'],
    images: [
      {
        _id: '6784e253147469001c511676',
        url: 'https://lin.ee/3A2VJh5',
        __v: 0,
        image: {
          _id: '6784e214147469001c511674',
          name: 'Web24FIX banner.png',
          alternativeText: '',
          caption: '',
          hash: 'Web24_FIX_banner_ed0ace2775',
          ext: '.png',
          mime: 'image/png',
          size: 5947.38,
          width: 4000,
          height: 1309,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Web24_FIX_banner_ed0ace2775.png',
          formats: {
            thumbnail: {
              name: 'thumbnail_Web24FIX banner.png',
              hash: 'thumbnail_Web24_FIX_banner_ed0ace2775',
              ext: '.png',
              mime: 'image/png',
              width: 245,
              height: 80,
              size: 48.1,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Web24_FIX_banner_ed0ace2775.png',
            },
            large: {
              name: 'large_Web24FIX banner.png',
              hash: 'large_Web24_FIX_banner_ed0ace2775',
              ext: '.png',
              mime: 'image/png',
              width: 1000,
              height: 327,
              size: 601.77,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Web24_FIX_banner_ed0ace2775.png',
            },
            medium: {
              name: 'medium_Web24FIX banner.png',
              hash: 'medium_Web24_FIX_banner_ed0ace2775',
              ext: '.png',
              mime: 'image/png',
              width: 750,
              height: 245,
              size: 356.96,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Web24_FIX_banner_ed0ace2775.png',
            },
            small: {
              name: 'small_Web24FIX banner.png',
              hash: 'small_Web24_FIX_banner_ed0ace2775',
              ext: '.png',
              mime: 'image/png',
              width: 500,
              height: 164,
              size: 172.28,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Web24_FIX_banner_ed0ace2775.png',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2025-01-13T09:51:16.657Z',
          updatedAt: '2025-01-13T13:10:59.418Z',
          __v: 0,
          id: '6784e214147469001c511674',
        },
        id: '6784e253147469001c511676',
      },
      {
        _id: '63d220364c9e1c001b26d135',
        url: 'https://business.24x.co.th/th',
        __v: 0,
        image: {
          _id: '63d220274c9e1c001b26d133',
          name: '24BUCR_JAN_BANNER.jpg',
          alternativeText: '',
          caption: '',
          hash: '24_BUCR_JAN_BANNER_d78a8592a3',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 1715.28,
          width: 9000,
          height: 2938,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/24_BUCR_JAN_BANNER_d78a8592a3.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_24BUCR_JAN_BANNER.jpg',
              hash: 'thumbnail_24_BUCR_JAN_BANNER_d78a8592a3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 245,
              height: 80,
              size: 5.57,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_24_BUCR_JAN_BANNER_d78a8592a3.jpg',
            },
            large: {
              name: 'large_24BUCR_JAN_BANNER.jpg',
              hash: 'large_24_BUCR_JAN_BANNER_d78a8592a3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 326,
              size: 57.91,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_24_BUCR_JAN_BANNER_d78a8592a3.jpg',
            },
            medium: {
              name: 'medium_24BUCR_JAN_BANNER.jpg',
              hash: 'medium_24_BUCR_JAN_BANNER_d78a8592a3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 245,
              size: 36.46,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_24_BUCR_JAN_BANNER_d78a8592a3.jpg',
            },
            small: {
              name: 'small_24BUCR_JAN_BANNER.jpg',
              hash: 'small_24_BUCR_JAN_BANNER_d78a8592a3',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 163,
              size: 18.44,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_24_BUCR_JAN_BANNER_d78a8592a3.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2023-01-26T06:39:35.285Z',
          updatedAt: '2023-01-26T13:06:22.981Z',
          __v: 0,
          id: '63d220274c9e1c001b26d133',
        },
        id: '63d220364c9e1c001b26d135',
      },
    ],
    id: '608137bb3baea332542c66be',
  },
  categorySection: {
    _id: '608138533baea332542c66c5',
    serviceCategories: [
      '613efeb93f0e6844e0eb6bb7',
      '619722986e903e001b93bfeb',
      '613efeb93f0e6844e0eb6bb3',
      '613efeb93f0e6844e0eb6bb5',
      '613efeb93f0e6844e0eb6bb9',
      '62a49685e9dde5001b3c52dd',
      '62a49f22e9dde5001b3c539c',
      '619533e2cbe45a001b24417f',
      '62a5ce67e9dde5001b3c5be0',
    ],
    title: 'เลือกบริการที่คุณต้องการ',
    button: [
      {
        _id: '633d3cac5abbcb001c862c00',
        kind: 'ComponentLinksButtonLink',
        ref: '608138533baea332542c66c6',
      },
    ],
    __v: 1,
    newCategories: [
      {
        _id: '633be6795abbcb001c862aba',
        url: 'cleanac',
        name: 'ล้างแอร์',
        __v: 0,
        image: {
          _id: '633d3c9d5abbcb001c862bf6',
          name: 'ล้างแอร์-min.jpg',
          alternativeText: '',
          caption: '',
          hash: 'min_912ac98487',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 152.78,
          width: 1200,
          height: 1200,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/min_912ac98487.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_ล้างแอร์-min.jpg',
              hash: 'thumbnail_min_912ac98487',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 5.5,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_min_912ac98487.jpg',
            },
            large: {
              name: 'large_ล้างแอร์-min.jpg',
              hash: 'large_min_912ac98487',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 1000,
              size: 109.52,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_min_912ac98487.jpg',
            },
            medium: {
              name: 'medium_ล้างแอร์-min.jpg',
              hash: 'medium_min_912ac98487',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 750,
              size: 65.32,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_min_912ac98487.jpg',
            },
            small: {
              name: 'small_ล้างแอร์-min.jpg',
              hash: 'small_min_912ac98487',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 500,
              size: 32.43,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_min_912ac98487.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-05T08:13:17.059Z',
          updatedAt: '2022-10-05T12:40:36.964Z',
          __v: 0,
          id: '633d3c9d5abbcb001c862bf6',
        },
        id: '633be6795abbcb001c862aba',
      },
      {
        _id: '633570fd412025001cc50fd8',
        name: 'งานแอร์',
        url: 'air-conditioner',
        __v: 0,
        image: {
          _id: '634fa859d3b048001c0009df',
          name: 'แอร์.jpg',
          alternativeText: '',
          caption: '',
          hash: '_3eecca310a',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 9.98,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_3eecca310a.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_แอร์.jpg',
              hash: 'thumbnail__3eecca310a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 3.85,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__3eecca310a.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:33:45.394Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa859d3b048001c0009df',
        },
        id: '633570fd412025001cc50fd8',
      },
      {
        _id: '633d00325abbcb001c862b2a',
        url: 'washing-machine',
        name: 'ล้างเครื่องซักผ้า',
        __v: 0,
        image: {
          _id: '633d0b355abbcb001c862b56',
          name: 'shutterstock_1562454151-02-min.jpg',
          alternativeText: '',
          caption: '',
          hash: 'shutterstock_1562454151_02_min_d80cc7f3fd',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 552.73,
          width: 4500,
          height: 4500,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_shutterstock_1562454151-02-min.jpg',
              hash: 'thumbnail_shutterstock_1562454151_02_min_d80cc7f3fd',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 6.42,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
            },
            large: {
              name: 'large_shutterstock_1562454151-02-min.jpg',
              hash: 'large_shutterstock_1562454151_02_min_d80cc7f3fd',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 1000,
              size: 93.41,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
            },
            medium: {
              name: 'medium_shutterstock_1562454151-02-min.jpg',
              hash: 'medium_shutterstock_1562454151_02_min_d80cc7f3fd',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 750,
              size: 61.2,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
            },
            small: {
              name: 'small_shutterstock_1562454151-02-min.jpg',
              hash: 'small_shutterstock_1562454151_02_min_d80cc7f3fd',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 500,
              size: 33.58,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_shutterstock_1562454151_02_min_d80cc7f3fd.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-05T04:42:29.739Z',
          updatedAt: '2022-10-05T12:40:36.964Z',
          __v: 0,
          id: '633d0b355abbcb001c862b56',
        },
        id: '633d00325abbcb001c862b2a',
      },
      {
        _id: '633570fd412025001cc50fdc',
        name: 'งานไฟฟ้า',
        url: 'electrical',
        __v: 0,
        image: {
          _id: '634fa9e3d3b048001c0009e4',
          name: 'ไฟฟ้า.jpg',
          alternativeText: '',
          caption: '',
          hash: '_1245a9516f',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 18.23,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_1245a9516f.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_ไฟฟ้า.jpg',
              hash: 'thumbnail__1245a9516f',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 6.37,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__1245a9516f.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:40:19.897Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa9e3d3b048001c0009e4',
        },
        id: '633570fd412025001cc50fdc',
      },
      {
        _id: '633570fd412025001cc50fd9',
        name: 'งานประปาและห้องน้ำ',
        url: 'piping',
        __v: 0,
        image: {
          _id: '634fa661d3b048001c0009b7',
          name: 'ประปา.jpg',
          alternativeText: '',
          caption: '',
          hash: '_e16aabaf47',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 49.15,
          width: 640,
          height: 640,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_e16aabaf47.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_ประปา.jpg',
              hash: 'thumbnail__e16aabaf47',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 5.92,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__e16aabaf47.jpg',
            },
            small: {
              name: 'small_ประปา.jpg',
              hash: 'small__e16aabaf47',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 500,
              size: 34.52,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small__e16aabaf47.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:25:21.920Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa661d3b048001c0009b7',
        },
        id: '633570fd412025001cc50fd9',
      },
      {
        _id: '633570fd412025001cc50fd7',
        url: 'tile',
        name: 'งานกระเบื้อง',
        __v: 0,
        image: {
          _id: '634fa476d3b048001c000990',
          name: 'กระเบื้อง.jpg',
          alternativeText: '',
          caption: '',
          hash: '_8721f7053a',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 19.62,
          width: 640,
          height: 640,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_8721f7053a.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_กระเบื้อง.jpg',
              hash: 'thumbnail__8721f7053a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 2.17,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__8721f7053a.jpg',
            },
            small: {
              name: 'small_กระเบื้อง.jpg',
              hash: 'small__8721f7053a',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 500,
              size: 14.21,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small__8721f7053a.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:17:10.602Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa476d3b048001c000990',
        },
        id: '633570fd412025001cc50fd7',
      },
      {
        _id: '636b89357b723a001cc98827',
        name: 'ซ่อมยาแนว',
        url: 'grout',
        __v: 0,
        image: {
          _id: '636b8b177b723a001cc98a62',
          name: 'shutterstock_474982279-min (1).jpg',
          alternativeText: '',
          caption: '',
          hash: 'shutterstock_474982279_min_1_c5938f3102',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 424.16,
          width: 2266,
          height: 2266,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/shutterstock_474982279_min_1_c5938f3102.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_shutterstock_474982279-min (1).jpg',
              hash: 'thumbnail_shutterstock_474982279_min_1_c5938f3102',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 5.3,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_shutterstock_474982279_min_1_c5938f3102.jpg',
            },
            large: {
              name: 'large_shutterstock_474982279-min (1).jpg',
              hash: 'large_shutterstock_474982279_min_1_c5938f3102',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 1000,
              height: 1000,
              size: 164.52,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_shutterstock_474982279_min_1_c5938f3102.jpg',
            },
            medium: {
              name: 'medium_shutterstock_474982279-min (1).jpg',
              hash: 'medium_shutterstock_474982279_min_1_c5938f3102',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 750,
              height: 750,
              size: 100.24,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_shutterstock_474982279_min_1_c5938f3102.jpg',
            },
            small: {
              name: 'small_shutterstock_474982279-min (1).jpg',
              hash: 'small_shutterstock_474982279_min_1_c5938f3102',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 500,
              size: 45.51,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_shutterstock_474982279_min_1_c5938f3102.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-09T11:12:23.012Z',
          updatedAt: '2022-11-10T05:18:00.476Z',
          __v: 0,
          id: '636b8b177b723a001cc98a62',
        },
        id: '636b89357b723a001cc98827',
      },
      {
        _id: '633570fd412025001cc50fdf',
        name: 'งานพื้น',
        url: 'floor',
        __v: 0,
        image: {
          _id: '634fa907d3b048001c0009e3',
          name: 'พื้น.jpg',
          alternativeText: '',
          caption: '',
          hash: '_065a858550',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 5.17,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_065a858550.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_พื้น.jpg',
              hash: 'thumbnail__065a858550',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 1.85,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__065a858550.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:36:39.811Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa907d3b048001c0009e3',
        },
        id: '633570fd412025001cc50fdf',
      },
      {
        _id: '63878547dda467001cc0c8b1',
        name: 'งานผนัง',
        url: 'wall',
        __v: 0,
        image: {
          _id: '638784f1dda467001cc0c8a8',
          name: 'Service_USP-01.jpg',
          alternativeText: '',
          caption: '',
          hash: 'Service_USP_01_3e0876e0e6',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 19.16,
          width: 509,
          height: 342,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/Service_USP_01_3e0876e0e6.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_Service_USP-01.jpg',
              hash: 'thumbnail_Service_USP_01_3e0876e0e6',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 232,
              height: 156,
              size: 4.44,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Service_USP_01_3e0876e0e6.jpg',
            },
            small: {
              name: 'small_Service_USP-01.jpg',
              hash: 'small_Service_USP_01_3e0876e0e6',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 336,
              size: 17.82,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Service_USP_01_3e0876e0e6.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-11-30T16:29:37.772Z',
          updatedAt: '2022-12-01T03:06:38.322Z',
          __v: 0,
          id: '638784f1dda467001cc0c8a8',
        },
        id: '63878547dda467001cc0c8b1',
      },
      {
        _id: '633570fd412025001cc50fde',
        name: 'งานทาสี',
        url: 'color',
        __v: 0,
        image: {
          _id: '634fa8dfd3b048001c0009e2',
          name: 'สี.jpg',
          alternativeText: '',
          caption: '',
          hash: '_9138779e9d',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 6.23,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_9138779e9d.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_สี.jpg',
              hash: 'thumbnail__9138779e9d',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 2.5,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__9138779e9d.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:35:59.433Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa8dfd3b048001c0009e2',
        },
        id: '633570fd412025001cc50fde',
      },
      {
        _id: '633570fd412025001cc50fda',
        name: 'งานฝ้าและเพดาน',
        url: 'ceiling',
        __v: 0,
        image: {
          _id: '634fa894d3b048001c0009e0',
          name: 'ฝ้า.jpg',
          alternativeText: '',
          caption: '',
          hash: '_a2780e51a6',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 8.02,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_a2780e51a6.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_ฝ้า.jpg',
              hash: 'thumbnail__a2780e51a6',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 2.77,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__a2780e51a6.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:34:44.646Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa894d3b048001c0009e0',
        },
        id: '633570fd412025001cc50fda',
      },
      {
        _id: '633570fd412025001cc50fdb',
        name: 'งานหลังคาและดาดฟ้า',
        url: 'roof',
        __v: 0,
        image: {
          _id: '634fa8b9d3b048001c0009e1',
          name: 'หลังคา.jpg',
          alternativeText: '',
          caption: '',
          hash: '_31e4d7ab12',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 21.86,
          width: 320,
          height: 320,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/_31e4d7ab12.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_หลังคา.jpg',
              hash: 'thumbnail__31e4d7ab12',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 156,
              height: 156,
              size: 5.79,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail__31e4d7ab12.jpg',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-10-19T07:35:21.041Z',
          updatedAt: '2022-10-25T14:29:16.504Z',
          __v: 0,
          id: '634fa8b9d3b048001c0009e1',
        },
        id: '633570fd412025001cc50fdb',
      },
    ],
    id: '608138533baea332542c66c5',
  },
  promotionSection: {
    promotions: [],
    _id: '608139043baea332542c66cf',
    title: 'โปรโมชั่นสุดพิเศษ',
    button: {
      _id: '608139043baea332542c66d0',
      type: 'primary',
      text: 'ดูโปรโมชั่นอื่นๆ',
      newTab: false,
      __v: 0,
      id: '608139043baea332542c66d0',
    },
    __v: 1,
    icon: '60e7b8b675c7ab001bb5edd6',
    id: '608139043baea332542c66cf',
  },
  why24fixSection: {
    _id: '60813a3a3baea332542c66da',
    title: 'Why 24 FIX?',
    contents: [
      {
        _id: '60813a3a3baea332542c66db',
        title: 'QUALITY SERVICE',
        description:
          'ใส่ใจบริการทุกขั้นตอนนับตั้งแต่เริ่มต้นจนถึงจบงาน พร้อมบริการหลังการขาย (End-to-End Service)',
        __v: 0,
        icon: '',
        image: {
          _id: '62a6d9eae9dde5001b3c6496',
          name: 'icon-why-us-1.png',
          alternativeText: '',
          caption: '',
          hash: 'icon_why_us_1_6dbb4dd694',
          ext: '.png',
          mime: 'image/png',
          size: 1.09,
          width: 64,
          height: 64,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/icon_why_us_1_6dbb4dd694.png',
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-13T06:32:10.623Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a6d9eae9dde5001b3c6496',
        },
        id: '60813a3a3baea332542c66db',
      },
      {
        _id: '60813a3a3baea332542c66dc',
        title: 'STANDARD PRICE',
        description: 'ราคางานซ่อมที่ได้มาตรฐาน\nเชื่อถือได้คุ้มค่ากับคุณภาพบริการ',
        __v: 0,
        icon: '',
        image: {
          _id: '62a6da64e9dde5001b3c64a1',
          name: 'icon-why-us-3.png',
          alternativeText: '',
          caption: '',
          hash: 'icon_why_us_3_e9caac0334',
          ext: '.png',
          mime: 'image/png',
          size: 1.09,
          width: 64,
          height: 64,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/icon_why_us_3_e9caac0334.png',
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-13T06:34:12.596Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a6da64e9dde5001b3c64a1',
        },
        id: '60813a3a3baea332542c66dc',
      },
      {
        _id: '60813a3a3baea332542c66dd',
        title: 'PROFICIENT HANDYMAN',
        description:
          'มีช่างซ่อมมืออาชีพผ่านมาตรฐาน\nการคัดกรองพร้อมด้วยการอบรม\nการบริการ และการปฏิบัติงาน\n',
        __v: 0,
        icon: '',
        image: {
          _id: '62a6da9ce9dde5001b3c64a2',
          name: 'icon-why-us-4.png',
          alternativeText: '',
          caption: '',
          hash: 'icon_why_us_4_82c8a115f7',
          ext: '.png',
          mime: 'image/png',
          size: 0.88,
          width: 64,
          height: 64,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/icon_why_us_4_82c8a115f7.png',
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-13T06:35:08.353Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a6da9ce9dde5001b3c64a2',
        },
        id: '60813a3a3baea332542c66dd',
      },
      {
        _id: '60813a3a3baea332542c66de',
        title: 'QUALITY MATERIAL',
        description: 'มั่นใจในคุณภาพของวัสดุทุกงาน\nซ่อม และพร้อมราคาที่ได้มาตรฐาน',
        __v: 0,
        icon: '',
        image: {
          _id: '62a6dadfe9dde5001b3c64a3',
          name: 'icon-why-us-2.png',
          alternativeText: '',
          caption: '',
          hash: 'icon_why_us_2_0554062987',
          ext: '.png',
          mime: 'image/png',
          size: 1.08,
          width: 64,
          height: 64,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/icon_why_us_2_0554062987.png',
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-13T06:36:15.848Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a6dadfe9dde5001b3c64a3',
        },
        id: '60813a3a3baea332542c66de',
      },
    ],
    __v: 1,
    id: '60813a3a3baea332542c66da',
  },
  reviewSection: [
    {
      _id: '633d3cac5abbcb001c862c15',
      kind: 'ComponentHomeSectionsHomeReview',
      ref: '60813ac93baea332542c66f5',
    },
  ],
  createdAt: '2021-04-22T07:42:21.110Z',
  updatedAt: '2025-01-13T09:52:20.471Z',
  __v: 0,
  b2bSection: {
    _id: '60813eb58433ab11ac597a76',
    title: '24FIX For Business',
    description:
      'ไม่จำเป็นต้องมีช่างประจำอีกต่อไป จ้างช่างซ่อมสำหรับธุรกิจคุณไม่ว่าจะเป็น ร้านอาหาร โรงแรม ตึกออฟฟิศ เรามีบริการครบ มั่นใจในคุณภาพของวัสดุทุกงาน',
    button: {
      _id: '60813eb58433ab11ac597a77',
      type: 'primary',
      text: 'บริการสำหรับลูกค้าธุรกิจ',
      url: 'https://business.24x.co.th/th',
      newTab: false,
      __v: 0,
      id: '60813eb58433ab11ac597a77',
    },
    __v: 1,
    icon: {
      _id: '62ce598cdf69b2001b4aa25f',
      name: 'MicrosoftTeams-image (2) (1) (1).png',
      alternativeText: '',
      caption: '',
      hash: 'Microsoft_Teams_image_2_1_1_1ce46e6928',
      ext: '.png',
      mime: 'image/png',
      size: 12.31,
      width: 500,
      height: 245,
      url: 'https://d2jl6hozakvcbj.cloudfront.net/Microsoft_Teams_image_2_1_1_1ce46e6928.png',
      formats: {
        thumbnail: {
          name: 'thumbnail_MicrosoftTeams-image (2) (1) (1).png',
          hash: 'thumbnail_Microsoft_Teams_image_2_1_1_1ce46e6928',
          ext: '.png',
          mime: 'image/png',
          width: 245,
          height: 120,
          size: 10.5,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Microsoft_Teams_image_2_1_1_1ce46e6928.png',
        },
      },
      provider: 'aws-s3',
      related: [],
      createdAt: '2022-07-13T05:35:08.172Z',
      updatedAt: '2022-07-13T18:45:31.387Z',
      __v: 0,
      id: '62ce598cdf69b2001b4aa25f',
    },
    image: {
      _id: '60ff90f5ea7297001be8c723',
      name: 'Client_dashboard_Red (1).png',
      alternativeText: '',
      caption: '',
      hash: 'Client_dashboard_Red_1_0a5fcfd4be',
      ext: '.png',
      mime: 'image/png',
      size: 624.06,
      width: 3840,
      height: 2230,
      url: 'https://d2jl6hozakvcbj.cloudfront.net/Client_dashboard_Red_1_0a5fcfd4be.png',
      formats: {
        thumbnail: {
          name: 'thumbnail_Client_dashboard_Red (1).png',
          hash: 'thumbnail_Client_dashboard_Red_1_0a5fcfd4be',
          ext: '.png',
          mime: 'image/png',
          width: 245,
          height: 142,
          size: 26.08,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Client_dashboard_Red_1_0a5fcfd4be.png',
        },
        large: {
          name: 'large_Client_dashboard_Red (1).png',
          hash: 'large_Client_dashboard_Red_1_0a5fcfd4be',
          ext: '.png',
          mime: 'image/png',
          width: 1000,
          height: 581,
          size: 177.53,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/large_Client_dashboard_Red_1_0a5fcfd4be.png',
        },
        medium: {
          name: 'medium_Client_dashboard_Red (1).png',
          hash: 'medium_Client_dashboard_Red_1_0a5fcfd4be',
          ext: '.png',
          mime: 'image/png',
          width: 750,
          height: 436,
          size: 119.68,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_Client_dashboard_Red_1_0a5fcfd4be.png',
        },
        small: {
          name: 'small_Client_dashboard_Red (1).png',
          hash: 'small_Client_dashboard_Red_1_0a5fcfd4be',
          ext: '.png',
          mime: 'image/png',
          width: 500,
          height: 290,
          size: 67.3,
          path: null,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Client_dashboard_Red_1_0a5fcfd4be.png',
        },
      },
      provider: 'aws-s3',
      related: [],
      createdAt: '2021-07-27T04:52:05.635Z',
      updatedAt: '2021-07-30T04:53:40.384Z',
      __v: 0,
      id: '60ff90f5ea7297001be8c723',
    },
    id: '60813eb58433ab11ac597a76',
  },
  howWeWorkSection: {
    _id: '60813c848433ab11ac597a1d',
    title: 'วิธีการทำงานของเรา',
    contents: [
      {
        _id: '60813c848433ab11ac597a1e',
        title: '1. เลือกบริการที่ท่านต้องการ',
        __v: 0,
        icon: 'far fa-map-marked-alt',
        image: {
          _id: '62a1cd77e9dde5001b3c3b23',
          name: 'select service.png',
          alternativeText: '',
          caption: '',
          hash: 'select_service_319860f3f7',
          ext: '.png',
          mime: 'image/png',
          size: 225.45,
          width: 373,
          height: 765,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/select_service_319860f3f7.png',
          formats: {
            thumbnail: {
              name: 'thumbnail_select service.png',
              hash: 'thumbnail_select_service_319860f3f7',
              ext: '.png',
              mime: 'image/png',
              width: 76,
              height: 156,
              size: 19.04,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_select_service_319860f3f7.png',
            },
            medium: {
              name: 'medium_select service.png',
              hash: 'medium_select_service_319860f3f7',
              ext: '.png',
              mime: 'image/png',
              width: 366,
              height: 750,
              size: 286.71,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_select_service_319860f3f7.png',
            },
            small: {
              name: 'small_select service.png',
              hash: 'small_select_service_319860f3f7',
              ext: '.png',
              mime: 'image/png',
              width: 244,
              height: 500,
              size: 138.5,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_select_service_319860f3f7.png',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-09T10:37:43.767Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a1cd77e9dde5001b3c3b23',
        },
        id: '60813c848433ab11ac597a1e',
      },
      {
        _id: '60813c848433ab11ac597a1f',
        title: '2. เลือกวันเวลานัดหมายที่ท่านสะดวก',
        __v: 0,
        icon: 'fad fa-paste',
        image: {
          _id: '62a1cda3e9dde5001b3c3b24',
          name: 'select date-time.png',
          alternativeText: '',
          caption: '',
          hash: 'select_date_time_e5ee90ff09',
          ext: '.png',
          mime: 'image/png',
          size: 23.26,
          width: 287,
          height: 683,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/select_date_time_e5ee90ff09.png',
          formats: {
            thumbnail: {
              name: 'thumbnail_select date-time.png',
              hash: 'thumbnail_select_date_time_e5ee90ff09',
              ext: '.png',
              mime: 'image/png',
              width: 66,
              height: 156,
              size: 7.19,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_select_date_time_e5ee90ff09.png',
            },
            small: {
              name: 'small_select date-time.png',
              hash: 'small_select_date_time_e5ee90ff09',
              ext: '.png',
              mime: 'image/png',
              width: 210,
              height: 500,
              size: 35.84,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_select_date_time_e5ee90ff09.png',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-06-09T10:38:27.270Z',
          updatedAt: '2022-07-01T06:56:39.809Z',
          __v: 0,
          id: '62a1cda3e9dde5001b3c3b24',
        },
        id: '60813c848433ab11ac597a1f',
      },
      {
        _id: '60813c848433ab11ac597a20',
        title: '3. ชำระค่าบริการเพื่ออนุมัติคิวช่าง',
        __v: 0,
        icon: 'fad fa-credit-card-front',
        image: {
          _id: '62e8e60265b749001babf5d3',
          name: 'select parment new.png',
          alternativeText: '',
          caption: '',
          hash: 'select_parment_new_29ac0371e4',
          ext: '.png',
          mime: 'image/png',
          size: 31.98,
          width: 353,
          height: 796,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/select_parment_new_29ac0371e4.png',
          formats: {
            thumbnail: {
              name: 'thumbnail_select parment new.png',
              hash: 'thumbnail_select_parment_new_29ac0371e4',
              ext: '.png',
              mime: 'image/png',
              width: 69,
              height: 156,
              size: 6.11,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_select_parment_new_29ac0371e4.png',
            },
            medium: {
              name: 'medium_select parment new.png',
              hash: 'medium_select_parment_new_29ac0371e4',
              ext: '.png',
              mime: 'image/png',
              width: 333,
              height: 750,
              size: 65.67,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_select_parment_new_29ac0371e4.png',
            },
            small: {
              name: 'small_select parment new.png',
              hash: 'small_select_parment_new_29ac0371e4',
              ext: '.png',
              mime: 'image/png',
              width: 222,
              height: 500,
              size: 35.37,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_select_parment_new_29ac0371e4.png',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-08-02T08:53:23.008Z',
          updatedAt: '2022-08-03T14:43:50.095Z',
          __v: 0,
          id: '62e8e60265b749001babf5d3',
        },
        id: '60813c848433ab11ac597a20',
      },
      {
        _id: '62a1bb2ee9dde5001b3c38c5',
        title: '4. รับบริการงานซ่อมตามนัดหมาย',
        __v: 0,
        image: {
          _id: '62eb41795fcbdc001c8c2c5d',
          name: 'B2CNew24Fix_Mobile_Booking Confirmation.png',
          alternativeText: '',
          caption: '',
          hash: 'B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a',
          ext: '.png',
          mime: 'image/png',
          size: 46.8,
          width: 375,
          height: 839,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a.png',
          formats: {
            thumbnail: {
              name: 'thumbnail_B2CNew24Fix_Mobile_Booking Confirmation.png',
              hash: 'thumbnail_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a',
              ext: '.png',
              mime: 'image/png',
              width: 70,
              height: 156,
              size: 8.55,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a.png',
            },
            medium: {
              name: 'medium_B2CNew24Fix_Mobile_Booking Confirmation.png',
              hash: 'medium_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a',
              ext: '.png',
              mime: 'image/png',
              width: 335,
              height: 750,
              size: 98.41,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a.png',
            },
            small: {
              name: 'small_B2CNew24Fix_Mobile_Booking Confirmation.png',
              hash: 'small_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a',
              ext: '.png',
              mime: 'image/png',
              width: 223,
              height: 500,
              size: 49.41,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_B2_C_New24_Fix_Mobile_Booking_Confirmation_7d85dfa97a.png',
            },
          },
          provider: 'aws-s3',
          related: [],
          createdAt: '2022-08-04T03:48:09.290Z',
          updatedAt: '2022-08-04T15:34:29.983Z',
          __v: 0,
          id: '62eb41795fcbdc001c8c2c5d',
        },
        id: '62a1bb2ee9dde5001b3c38c5',
      },
    ],
    __v: 1,
    id: '60813c848433ab11ac597a1d',
  },
  ourClientSection: {
    logos: [
      {
        _id: '62b96ad2e9dde5001b3d09bc',
        name: 'ATMTEABAR.png',
        alternativeText: '',
        caption: '',
        hash: 'ATMTEABAR_eee0050184',
        ext: '.png',
        mime: 'image/png',
        size: 123.64,
        width: 1200,
        height: 1200,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/ATMTEABAR_eee0050184.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_ATMTEABAR.png',
            hash: 'thumbnail_ATMTEABAR_eee0050184',
            ext: '.png',
            mime: 'image/png',
            width: 156,
            height: 156,
            size: 10.17,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_ATMTEABAR_eee0050184.png',
          },
          large: {
            name: 'large_ATMTEABAR.png',
            hash: 'large_ATMTEABAR_eee0050184',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 1000,
            size: 108.68,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_ATMTEABAR_eee0050184.png',
          },
          medium: {
            name: 'medium_ATMTEABAR.png',
            hash: 'medium_ATMTEABAR_eee0050184',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 750,
            size: 71.91,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_ATMTEABAR_eee0050184.png',
          },
          small: {
            name: 'small_ATMTEABAR.png',
            hash: 'small_ATMTEABAR_eee0050184',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 500,
            size: 41.53,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_ATMTEABAR_eee0050184.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:31:14.272Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ad2e9dde5001b3d09bc',
      },
      {
        _id: '62b96ad2e9dde5001b3d09bd',
        name: 'BBQPLAZA.png',
        alternativeText: '',
        caption: '',
        hash: 'BBQPLAZA_35f75f42c2',
        ext: '.png',
        mime: 'image/png',
        size: 196.62,
        width: 1200,
        height: 389,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/BBQPLAZA_35f75f42c2.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_BBQPLAZA.png',
            hash: 'thumbnail_BBQPLAZA_35f75f42c2',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 79,
            size: 19.49,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_BBQPLAZA_35f75f42c2.png',
          },
          large: {
            name: 'large_BBQPLAZA.png',
            hash: 'large_BBQPLAZA_35f75f42c2',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 324,
            size: 177.71,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_BBQPLAZA_35f75f42c2.png',
          },
          medium: {
            name: 'medium_BBQPLAZA.png',
            hash: 'medium_BBQPLAZA_35f75f42c2',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 243,
            size: 111.24,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_BBQPLAZA_35f75f42c2.png',
          },
          small: {
            name: 'small_BBQPLAZA.png',
            hash: 'small_BBQPLAZA_35f75f42c2',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 162,
            size: 57.94,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_BBQPLAZA_35f75f42c2.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:31:14.439Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ad2e9dde5001b3d09bd',
      },
      {
        _id: '62b96ad2e9dde5001b3d09be',
        name: 'BITKUB.png',
        alternativeText: '',
        caption: '',
        hash: 'BITKUB_601b164670',
        ext: '.png',
        mime: 'image/png',
        size: 61.93,
        width: 2082,
        height: 589,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/BITKUB_601b164670.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_BITKUB.png',
            hash: 'thumbnail_BITKUB_601b164670',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 69,
            size: 8.05,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_BITKUB_601b164670.png',
          },
          large: {
            name: 'large_BITKUB.png',
            hash: 'large_BITKUB_601b164670',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 283,
            size: 55.34,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_BITKUB_601b164670.png',
          },
          medium: {
            name: 'medium_BITKUB.png',
            hash: 'medium_BITKUB_601b164670',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 212,
            size: 37.51,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_BITKUB_601b164670.png',
          },
          small: {
            name: 'small_BITKUB.png',
            hash: 'small_BITKUB_601b164670',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 141,
            size: 21.29,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_BITKUB_601b164670.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:31:14.731Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ad2e9dde5001b3d09be',
      },
      {
        _id: '62b96d17e9dde5001b3d0a08',
        name: 'CENTRALONLINE.png',
        alternativeText: '',
        caption: '',
        hash: 'CENTRALONLINE_258c735b7c',
        ext: '.png',
        mime: 'image/png',
        size: 47.37,
        width: 755,
        height: 374,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/CENTRALONLINE_258c735b7c.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_CENTRALONLINE.png',
            hash: 'thumbnail_CENTRALONLINE_258c735b7c',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 121,
            size: 19.47,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_CENTRALONLINE_258c735b7c.png',
          },
          medium: {
            name: 'medium_CENTRALONLINE.png',
            hash: 'medium_CENTRALONLINE_258c735b7c',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 372,
            size: 95.6,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_CENTRALONLINE_258c735b7c.png',
          },
          small: {
            name: 'small_CENTRALONLINE.png',
            hash: 'small_CENTRALONLINE_258c735b7c',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 248,
            size: 53.95,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_CENTRALONLINE_258c735b7c.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:40:55.389Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d17e9dde5001b3d0a08',
      },
      {
        _id: '62b96d17e9dde5001b3d0a09',
        name: 'BREADTALK.png',
        alternativeText: '',
        caption: '',
        hash: 'BREADTALK_6af8850555',
        ext: '.png',
        mime: 'image/png',
        size: 66.08,
        width: 1084,
        height: 260,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/BREADTALK_6af8850555.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_BREADTALK.png',
            hash: 'thumbnail_BREADTALK_6af8850555',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 59,
            size: 12.4,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_BREADTALK_6af8850555.png',
          },
          large: {
            name: 'large_BREADTALK.png',
            hash: 'large_BREADTALK_6af8850555',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 240,
            size: 98.73,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_BREADTALK_6af8850555.png',
          },
          medium: {
            name: 'medium_BREADTALK.png',
            hash: 'medium_BREADTALK_6af8850555',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 180,
            size: 63.97,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_BREADTALK_6af8850555.png',
          },
          small: {
            name: 'small_BREADTALK.png',
            hash: 'small_BREADTALK_6af8850555',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 120,
            size: 35.04,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_BREADTALK_6af8850555.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:40:55.667Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d17e9dde5001b3d0a09',
      },
      {
        _id: '62b96d18e9dde5001b3d0a0a',
        name: 'BONCHON.png',
        alternativeText: '',
        caption: '',
        hash: 'BONCHON_42a80f26bc',
        ext: '.png',
        mime: 'image/png',
        size: 195.31,
        width: 1200,
        height: 1116,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/BONCHON_42a80f26bc.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_BONCHON.png',
            hash: 'thumbnail_BONCHON_42a80f26bc',
            ext: '.png',
            mime: 'image/png',
            width: 168,
            height: 156,
            size: 16.27,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_BONCHON_42a80f26bc.png',
          },
          large: {
            name: 'large_BONCHON.png',
            hash: 'large_BONCHON_42a80f26bc',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 930,
            size: 200.31,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_BONCHON_42a80f26bc.png',
          },
          medium: {
            name: 'medium_BONCHON.png',
            hash: 'medium_BONCHON_42a80f26bc',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 698,
            size: 135.67,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_BONCHON_42a80f26bc.png',
          },
          small: {
            name: 'small_BONCHON.png',
            hash: 'small_BONCHON_42a80f26bc',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 465,
            size: 78.54,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_BONCHON_42a80f26bc.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:40:56.073Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d18e9dde5001b3d0a0a',
      },
      {
        _id: '62b96d59e9dde5001b3d0a0b',
        name: 'CIVIC.png',
        alternativeText: '',
        caption: '',
        hash: 'CIVIC_0224d7e169',
        ext: '.png',
        mime: 'image/png',
        size: 60.85,
        width: 397,
        height: 595,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/CIVIC_0224d7e169.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_CIVIC.png',
            hash: 'thumbnail_CIVIC_0224d7e169',
            ext: '.png',
            mime: 'image/png',
            width: 104,
            height: 156,
            size: 12.66,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_CIVIC_0224d7e169.png',
          },
          small: {
            name: 'small_CIVIC.png',
            hash: 'small_CIVIC_0224d7e169',
            ext: '.png',
            mime: 'image/png',
            width: 334,
            height: 500,
            size: 65.72,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_CIVIC_0224d7e169.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:01.961Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d59e9dde5001b3d0a0b',
      },
      {
        _id: '62b96d5ae9dde5001b3d0a0c',
        name: 'DUNLOPILO.png',
        alternativeText: '',
        caption: '',
        hash: 'DUNLOPILO_dc95227157',
        ext: '.png',
        mime: 'image/png',
        size: 68.54,
        width: 445,
        height: 445,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/DUNLOPILO_dc95227157.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_DUNLOPILO.png',
            hash: 'thumbnail_DUNLOPILO_dc95227157',
            ext: '.png',
            mime: 'image/png',
            width: 156,
            height: 156,
            size: 29.08,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_DUNLOPILO_dc95227157.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:02.447Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d5ae9dde5001b3d0a0c',
      },
      {
        _id: '62b96d5ae9dde5001b3d0a0d',
        name: 'DINTAIFUNG.png',
        alternativeText: '',
        caption: '',
        hash: 'DINTAIFUNG_4452f97994',
        ext: '.png',
        mime: 'image/png',
        size: 351.55,
        width: 1200,
        height: 434,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/DINTAIFUNG_4452f97994.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_DINTAIFUNG.png',
            hash: 'thumbnail_DINTAIFUNG_4452f97994',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 89,
            size: 34.41,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_DINTAIFUNG_4452f97994.png',
          },
          large: {
            name: 'large_DINTAIFUNG.png',
            hash: 'large_DINTAIFUNG_4452f97994',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 362,
            size: 311.04,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_DINTAIFUNG_4452f97994.png',
          },
          medium: {
            name: 'medium_DINTAIFUNG.png',
            hash: 'medium_DINTAIFUNG_4452f97994',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 271,
            size: 194.36,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_DINTAIFUNG_4452f97994.png',
          },
          small: {
            name: 'small_DINTAIFUNG.png',
            hash: 'small_DINTAIFUNG_4452f97994',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 181,
            size: 103.84,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_DINTAIFUNG_4452f97994.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:02.791Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d5ae9dde5001b3d0a0d',
      },
      {
        _id: '62b96d8ae9dde5001b3d0a0e',
        name: 'JASMINE.png',
        alternativeText: '',
        caption: '',
        hash: 'JASMINE_162dc39190',
        ext: '.png',
        mime: 'image/png',
        size: 6.83,
        width: 369,
        height: 148,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/JASMINE_162dc39190.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_JASMINE.png',
            hash: 'thumbnail_JASMINE_162dc39190',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 98,
            size: 15.2,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_JASMINE_162dc39190.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:50.653Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d8ae9dde5001b3d0a0e',
      },
      {
        _id: '62b96d8ae9dde5001b3d0a0f',
        name: 'Getfresh.png',
        alternativeText: '',
        caption: '',
        hash: 'Getfresh_5ebcf32eee',
        ext: '.png',
        mime: 'image/png',
        size: 25.66,
        width: 693,
        height: 692,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/Getfresh_5ebcf32eee.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_Getfresh.png',
            hash: 'thumbnail_Getfresh_5ebcf32eee',
            ext: '.png',
            mime: 'image/png',
            width: 156,
            height: 156,
            size: 7.6,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_Getfresh_5ebcf32eee.png',
          },
          small: {
            name: 'small_Getfresh.png',
            hash: 'small_Getfresh_5ebcf32eee',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 499,
            size: 40.43,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_Getfresh_5ebcf32eee.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:50.764Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d8ae9dde5001b3d0a0f',
      },
      {
        _id: '62b96d8be9dde5001b3d0a10',
        name: 'JETTS.png',
        alternativeText: '',
        caption: '',
        hash: 'JETTS_0805e7fe74',
        ext: '.png',
        mime: 'image/png',
        size: 379.69,
        width: 1200,
        height: 830,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/JETTS_0805e7fe74.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_JETTS.png',
            hash: 'thumbnail_JETTS_0805e7fe74',
            ext: '.png',
            mime: 'image/png',
            width: 226,
            height: 156,
            size: 37.7,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_JETTS_0805e7fe74.png',
          },
          large: {
            name: 'large_JETTS.png',
            hash: 'large_JETTS_0805e7fe74',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 692,
            size: 371.41,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_JETTS_0805e7fe74.png',
          },
          medium: {
            name: 'medium_JETTS.png',
            hash: 'medium_JETTS_0805e7fe74',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 519,
            size: 233.12,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_JETTS_0805e7fe74.png',
          },
          small: {
            name: 'small_JETTS.png',
            hash: 'small_JETTS_0805e7fe74',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 346,
            size: 123.5,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_JETTS_0805e7fe74.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:42:51.471Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96d8be9dde5001b3d0a10',
      },
      {
        _id: '62b96dade9dde5001b3d0a11',
        name: 'KLM.png',
        alternativeText: '',
        caption: '',
        hash: 'KLM_2661210052',
        ext: '.png',
        mime: 'image/png',
        size: 16.08,
        width: 514,
        height: 301,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/KLM_2661210052.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_KLM.png',
            hash: 'thumbnail_KLM_2661210052',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 143,
            size: 13.67,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_KLM_2661210052.png',
          },
          small: {
            name: 'small_KLM.png',
            hash: 'small_KLM_2661210052',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 293,
            size: 36.2,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_KLM_2661210052.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:43:25.521Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96dade9dde5001b3d0a11',
      },
      {
        _id: '62b96dade9dde5001b3d0a12',
        name: 'MCM.png',
        alternativeText: '',
        caption: '',
        hash: 'MCM_df9ece38a6',
        ext: '.png',
        mime: 'image/png',
        size: 65.19,
        width: 306,
        height: 307,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/MCM_df9ece38a6.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_MCM.png',
            hash: 'thumbnail_MCM_df9ece38a6',
            ext: '.png',
            mime: 'image/png',
            width: 155,
            height: 156,
            size: 35.69,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_MCM_df9ece38a6.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:43:25.765Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96dade9dde5001b3d0a12',
      },
      {
        _id: '62b96daee9dde5001b3d0a13',
        name: 'LUKKAITHONG.png',
        alternativeText: '',
        caption: '',
        hash: 'LUKKAITHONG_cb75cef250',
        ext: '.png',
        mime: 'image/png',
        size: 260.03,
        width: 1200,
        height: 900,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/LUKKAITHONG_cb75cef250.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_LUKKAITHONG.png',
            hash: 'thumbnail_LUKKAITHONG_cb75cef250',
            ext: '.png',
            mime: 'image/png',
            width: 208,
            height: 156,
            size: 24.14,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_LUKKAITHONG_cb75cef250.png',
          },
          large: {
            name: 'large_LUKKAITHONG.png',
            hash: 'large_LUKKAITHONG_cb75cef250',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 750,
            size: 243.01,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_LUKKAITHONG_cb75cef250.png',
          },
          medium: {
            name: 'medium_LUKKAITHONG.png',
            hash: 'medium_LUKKAITHONG_cb75cef250',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 563,
            size: 156.84,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_LUKKAITHONG_cb75cef250.png',
          },
          small: {
            name: 'small_LUKKAITHONG.png',
            hash: 'small_LUKKAITHONG_cb75cef250',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 375,
            size: 86.45,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_LUKKAITHONG_cb75cef250.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:43:26.864Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96daee9dde5001b3d0a13',
      },
      {
        _id: '62b96e05e9dde5001b3d0a14',
        name: 'NARA.png',
        alternativeText: '',
        caption: '',
        hash: 'NARA_7f928abf42',
        ext: '.png',
        mime: 'image/png',
        size: 45.91,
        width: 402,
        height: 516,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/NARA_7f928abf42.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_NARA.png',
            hash: 'thumbnail_NARA_7f928abf42',
            ext: '.png',
            mime: 'image/png',
            width: 122,
            height: 156,
            size: 17.71,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_NARA_7f928abf42.png',
          },
          small: {
            name: 'small_NARA.png',
            hash: 'small_NARA_7f928abf42',
            ext: '.png',
            mime: 'image/png',
            width: 390,
            height: 500,
            size: 93.3,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_NARA_7f928abf42.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:44:53.156Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e05e9dde5001b3d0a14',
      },
      {
        _id: '62b96e05e9dde5001b3d0a15',
        name: 'MINISO.png',
        alternativeText: '',
        caption: '',
        hash: 'MINISO_32f79c1a63',
        ext: '.png',
        mime: 'image/png',
        size: 80.01,
        width: 1200,
        height: 1491,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/MINISO_32f79c1a63.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_MINISO.png',
            hash: 'thumbnail_MINISO_32f79c1a63',
            ext: '.png',
            mime: 'image/png',
            width: 126,
            height: 156,
            size: 12.52,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_MINISO_32f79c1a63.png',
          },
          large: {
            name: 'large_MINISO.png',
            hash: 'large_MINISO_32f79c1a63',
            ext: '.png',
            mime: 'image/png',
            width: 805,
            height: 1000,
            size: 101.78,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_MINISO_32f79c1a63.png',
          },
          medium: {
            name: 'medium_MINISO.png',
            hash: 'medium_MINISO_32f79c1a63',
            ext: '.png',
            mime: 'image/png',
            width: 604,
            height: 750,
            size: 69.31,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_MINISO_32f79c1a63.png',
          },
          small: {
            name: 'small_MINISO.png',
            hash: 'small_MINISO_32f79c1a63',
            ext: '.png',
            mime: 'image/png',
            width: 402,
            height: 500,
            size: 43.47,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_MINISO_32f79c1a63.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:44:53.590Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e05e9dde5001b3d0a15',
      },
      {
        _id: '62b96e0ee9dde5001b3d0a16',
        name: 'MEZZO.png',
        alternativeText: '',
        caption: '',
        hash: 'MEZZO_3a54e8b2a4',
        ext: '.png',
        mime: 'image/png',
        size: 81.74,
        width: 463,
        height: 428,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/MEZZO_3a54e8b2a4.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_MEZZO.png',
            hash: 'thumbnail_MEZZO_3a54e8b2a4',
            ext: '.png',
            mime: 'image/png',
            width: 169,
            height: 156,
            size: 32.78,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_MEZZO_3a54e8b2a4.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:45:02.738Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e0ee9dde5001b3d0a16',
      },
      {
        _id: '62b96e5de9dde5001b3d0a31',
        name: 'OAG.png',
        alternativeText: '',
        caption: '',
        hash: 'OAG_7bf680370f',
        ext: '.png',
        mime: 'image/png',
        size: 8.75,
        width: 459,
        height: 460,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/OAG_7bf680370f.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_OAG.png',
            hash: 'thumbnail_OAG_7bf680370f',
            ext: '.png',
            mime: 'image/png',
            width: 156,
            height: 156,
            size: 4.22,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_OAG_7bf680370f.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:46:21.429Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e5de9dde5001b3d0a31',
      },
      {
        _id: '62b96e5ee9dde5001b3d0a32',
        name: 'SHOPEE.png',
        alternativeText: '',
        caption: '',
        hash: 'SHOPEE_ee3c526365',
        ext: '.png',
        mime: 'image/png',
        size: 20.76,
        width: 553,
        height: 177,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/SHOPEE_ee3c526365.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_SHOPEE.png',
            hash: 'thumbnail_SHOPEE_ee3c526365',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 78,
            size: 16.23,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_SHOPEE_ee3c526365.png',
          },
          small: {
            name: 'small_SHOPEE.png',
            hash: 'small_SHOPEE_ee3c526365',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 160,
            size: 45.34,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_SHOPEE_ee3c526365.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:46:22.067Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e5ee9dde5001b3d0a32',
      },
      {
        _id: '62b96e60e9dde5001b3d0a33',
        name: 'POMELO.png',
        alternativeText: '',
        caption: '',
        hash: 'POMELO_8b5590cf8d',
        ext: '.png',
        mime: 'image/png',
        size: 12.71,
        width: 1024,
        height: 236,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/POMELO_8b5590cf8d.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_POMELO.png',
            hash: 'thumbnail_POMELO_8b5590cf8d',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 56,
            size: 9.95,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_POMELO_8b5590cf8d.png',
          },
          large: {
            name: 'large_POMELO.png',
            hash: 'large_POMELO_8b5590cf8d',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 230,
            size: 56.81,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_POMELO_8b5590cf8d.png',
          },
          medium: {
            name: 'medium_POMELO.png',
            hash: 'medium_POMELO_8b5590cf8d',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 173,
            size: 40.38,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_POMELO_8b5590cf8d.png',
          },
          small: {
            name: 'small_POMELO.png',
            hash: 'small_POMELO_8b5590cf8d',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 115,
            size: 24.05,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_POMELO_8b5590cf8d.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:46:24.572Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e60e9dde5001b3d0a33',
      },
      {
        _id: '62b96e92e9dde5001b3d0a37',
        name: 'SUHRING.png',
        alternativeText: '',
        caption: '',
        hash: 'SUHRING_93caf15ea1',
        ext: '.png',
        mime: 'image/png',
        size: 48.01,
        width: 1033,
        height: 258,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/SUHRING_93caf15ea1.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_SUHRING.png',
            hash: 'thumbnail_SUHRING_93caf15ea1',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 61,
            size: 10.05,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_SUHRING_93caf15ea1.png',
          },
          large: {
            name: 'large_SUHRING.png',
            hash: 'large_SUHRING_93caf15ea1',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 250,
            size: 86.48,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_SUHRING_93caf15ea1.png',
          },
          medium: {
            name: 'medium_SUHRING.png',
            hash: 'medium_SUHRING_93caf15ea1',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 187,
            size: 56.67,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_SUHRING_93caf15ea1.png',
          },
          small: {
            name: 'small_SUHRING.png',
            hash: 'small_SUHRING_93caf15ea1',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 125,
            size: 30.54,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_SUHRING_93caf15ea1.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:47:14.370Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e92e9dde5001b3d0a37',
      },
      {
        _id: '62b96e92e9dde5001b3d0a38',
        name: 'TIMHORTONS.png',
        alternativeText: '',
        caption: '',
        hash: 'TIMHORTONS_191b8ca28a',
        ext: '.png',
        mime: 'image/png',
        size: 71.77,
        width: 1469,
        height: 396,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/TIMHORTONS_191b8ca28a.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_TIMHORTONS.png',
            hash: 'thumbnail_TIMHORTONS_191b8ca28a',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 66,
            size: 13.73,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_TIMHORTONS_191b8ca28a.png',
          },
          large: {
            name: 'large_TIMHORTONS.png',
            hash: 'large_TIMHORTONS_191b8ca28a',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 270,
            size: 111.46,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_TIMHORTONS_191b8ca28a.png',
          },
          medium: {
            name: 'medium_TIMHORTONS.png',
            hash: 'medium_TIMHORTONS_191b8ca28a',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 202,
            size: 75.2,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_TIMHORTONS_191b8ca28a.png',
          },
          small: {
            name: 'small_TIMHORTONS.png',
            hash: 'small_TIMHORTONS_191b8ca28a',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 135,
            size: 41.91,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_TIMHORTONS_191b8ca28a.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:47:14.411Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e92e9dde5001b3d0a38',
      },
      {
        _id: '62b96e93e9dde5001b3d0a39',
        name: 'TOMANDTOM.png',
        alternativeText: '',
        caption: '',
        hash: 'TOMANDTOM_98d4810e46',
        ext: '.png',
        mime: 'image/png',
        size: 499.03,
        width: 1649,
        height: 1898,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/TOMANDTOM_98d4810e46.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_TOMANDTOM.png',
            hash: 'thumbnail_TOMANDTOM_98d4810e46',
            ext: '.png',
            mime: 'image/png',
            width: 136,
            height: 156,
            size: 16.11,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_TOMANDTOM_98d4810e46.png',
          },
          large: {
            name: 'large_TOMANDTOM.png',
            hash: 'large_TOMANDTOM_98d4810e46',
            ext: '.png',
            mime: 'image/png',
            width: 869,
            height: 1000,
            size: 218.27,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_TOMANDTOM_98d4810e46.png',
          },
          medium: {
            name: 'medium_TOMANDTOM.png',
            hash: 'medium_TOMANDTOM_98d4810e46',
            ext: '.png',
            mime: 'image/png',
            width: 652,
            height: 750,
            size: 136.99,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_TOMANDTOM_98d4810e46.png',
          },
          small: {
            name: 'small_TOMANDTOM.png',
            hash: 'small_TOMANDTOM_98d4810e46',
            ext: '.png',
            mime: 'image/png',
            width: 434,
            height: 500,
            size: 76.2,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_TOMANDTOM_98d4810e46.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:47:15.352Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96e93e9dde5001b3d0a39',
      },
      {
        _id: '62b96ebde9dde5001b3d0a3b',
        name: 'VTS.png',
        alternativeText: '',
        caption: '',
        hash: 'VTS_f530e07f72',
        ext: '.png',
        mime: 'image/png',
        size: 16.53,
        width: 639,
        height: 360,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/VTS_f530e07f72.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_VTS.png',
            hash: 'thumbnail_VTS_f530e07f72',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 138,
            size: 8.47,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_VTS_f530e07f72.png',
          },
          small: {
            name: 'small_VTS.png',
            hash: 'small_VTS_f530e07f72',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 282,
            size: 21.25,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_VTS_f530e07f72.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:47:57.895Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ebde9dde5001b3d0a3b',
      },
      {
        _id: '62b96ebde9dde5001b3d0a3a',
        name: 'TSURUHA.png',
        alternativeText: '',
        caption: '',
        hash: 'TSURUHA_d82d3bb4ee',
        ext: '.png',
        mime: 'image/png',
        size: 49,
        width: 469,
        height: 469,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/TSURUHA_d82d3bb4ee.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_TSURUHA.png',
            hash: 'thumbnail_TSURUHA_d82d3bb4ee',
            ext: '.png',
            mime: 'image/png',
            width: 156,
            height: 156,
            size: 16.86,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_TSURUHA_d82d3bb4ee.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:47:57.523Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ebde9dde5001b3d0a3a',
      },
      {
        _id: '62b96ec0e9dde5001b3d0a3c',
        name: 'TSUJIRI.png',
        alternativeText: '',
        caption: '',
        hash: 'TSUJIRI_a11f047cec',
        ext: '.png',
        mime: 'image/png',
        size: 153.67,
        width: 1500,
        height: 844,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/TSUJIRI_a11f047cec.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_TSUJIRI.png',
            hash: 'thumbnail_TSUJIRI_a11f047cec',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 138,
            size: 14.22,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_TSUJIRI_a11f047cec.png',
          },
          large: {
            name: 'large_TSUJIRI.png',
            hash: 'large_TSUJIRI_a11f047cec',
            ext: '.png',
            mime: 'image/png',
            width: 1000,
            height: 563,
            size: 96.91,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/large_TSUJIRI_a11f047cec.png',
          },
          medium: {
            name: 'medium_TSUJIRI.png',
            hash: 'medium_TSUJIRI_a11f047cec',
            ext: '.png',
            mime: 'image/png',
            width: 750,
            height: 422,
            size: 63.83,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_TSUJIRI_a11f047cec.png',
          },
          small: {
            name: 'small_TSUJIRI.png',
            hash: 'small_TSUJIRI_a11f047cec',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 281,
            size: 36.11,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_TSUJIRI_a11f047cec.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:48:00.660Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ec0e9dde5001b3d0a3c',
      },
      {
        _id: '62b96ef7e9dde5001b3d0a3d',
        name: 'WINE.png',
        alternativeText: '',
        caption: '',
        hash: 'WINE_2caeee4271',
        ext: '.png',
        mime: 'image/png',
        size: 33.49,
        width: 610,
        height: 305,
        url: 'https://d2jl6hozakvcbj.cloudfront.net/WINE_2caeee4271.png',
        formats: {
          thumbnail: {
            name: 'thumbnail_WINE.png',
            hash: 'thumbnail_WINE_2caeee4271',
            ext: '.png',
            mime: 'image/png',
            width: 245,
            height: 123,
            size: 20.53,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_WINE_2caeee4271.png',
          },
          small: {
            name: 'small_WINE.png',
            hash: 'small_WINE_2caeee4271',
            ext: '.png',
            mime: 'image/png',
            width: 500,
            height: 250,
            size: 56.48,
            path: null,
            url: 'https://d2jl6hozakvcbj.cloudfront.net/small_WINE_2caeee4271.png',
          },
        },
        provider: 'aws-s3',
        related: [],
        createdAt: '2022-06-27T08:48:55.967Z',
        updatedAt: '2022-07-01T06:56:39.809Z',
        __v: 0,
        id: '62b96ef7e9dde5001b3d0a3d',
      },
    ],
    _id: '60813eb68433ab11ac597a7c',
    title: 'กว่า 400 องค์กร ไว้วางใจเลือกใช้เรา',
    __v: 0,
    id: '60813eb68433ab11ac597a7c',
  },
  ourWorkSection: {
    contents: [
      {
        relatedArticles: [],
        categories: [
          '60d1fe825749bf001bbb11e4',
          '62a76933e9dde5001b3c6b15',
          '62de67ecb31a7a001bba2d60',
        ],
        _id: '60fef2feea7297001be8c5f3',
        title: 'รีวิวผลงานจริง ล้างแอร์บ้านคุณเมย์ รัชนก อินทนนท์',
        slug: 'pro-may-onsite-review',
        shortDescription:
          'เพราะประเทศไทยมีแต่ฤดูร้อน ร้อนมาก และร้อนที่สุด! ดังนั้นการดูแล ทำความสะอาด ล้างแอร์ ก็ควรทำอย่างสม่ำเสมอนะ\n#งานล้างแอร์ #ล้างแอร์ฆ่าเชื้อ #เมย์ รัชนก อินทนนท์ #แอร์ไม่เย็น #ตรวจสภาพแอร์ #ล้างแอร์ #ซ่อมแอร์ ',
        views: 3549,
        published_at: '2021-07-26T17:38:13.448Z',
        contents: [
          {
            __component: 'article.content',
            id: '60fef2feea7297001be8c5f4',
          },
          {
            __component: 'article.images',
            id: '60fef2feea7297001be8c5f5',
          },
          {
            __component: 'article.content',
            id: '60fef2feea7297001be8c5f6',
          },
          {
            __component: 'article.images',
            id: '60fef2feea7297001be8c5f7',
          },
          {
            __component: 'article.content',
            id: '62cd0500df69b2001b4a8f1a',
          },
          {
            __component: 'article.images',
            id: '62cd0687df69b2001b4a8f39',
          },
          {
            __component: 'article.content',
            id: '62cd0687df69b2001b4a8f3a',
          },
          {
            __component: 'article.images',
            id: '62cd0687df69b2001b4a8f3b',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fbc',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fbd',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fbe',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fbf',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fc0',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fc1',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fc2',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fc3',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fc4',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fc5',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fc6',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fc7',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fc8',
          },
          {
            __component: 'article.images',
            id: '62cd0a50df69b2001b4a8fc9',
          },
          {
            __component: 'article.content',
            id: '62cd0a50df69b2001b4a8fca',
          },
        ],
        link: null,
        createdAt: '2021-07-26T17:38:06.604Z',
        updatedAt: '2022-07-25T10:08:01.825Z',
        __v: 2,
        coverImage: {
          _id: '60feef59ea7297001be8c5ed',
          name: '20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
          alternativeText: '',
          caption: '',
          hash: '20210510_On_site_Review_Artboard_v2_e9212db564',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 657.65,
          width: 2501,
          height: 1667,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
          formats: {
            thumbnail: {
              name: 'thumbnail_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
              hash: 'thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 12.97,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            },
            large: {
              name: 'large_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
              hash: 'large_20210510_On_site_Review_Artboard_v2_e9212db564',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 1000,
              height: 667,
              size: 146.8,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            },
            medium: {
              name: 'medium_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
              hash: 'medium_20210510_On_site_Review_Artboard_v2_e9212db564',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 92.52,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            },
            small: {
              name: 'small_20210510_On-site Review พาชมบ้านเมย์รัชนก_Artboard_v2.jpeg',
              hash: 'small_20210510_On_site_Review_Artboard_v2_e9212db564',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 46.42,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_20210510_On_site_Review_Artboard_v2_e9212db564.jpeg',
            },
          },
          provider: 'aws-s3',
          related: ['60fef2feea7297001be8c5f3'],
          createdAt: '2021-07-26T17:22:33.885Z',
          updatedAt: '2021-07-30T03:43:47.943Z',
          __v: 0,
          id: '60feef59ea7297001be8c5ed',
        },
        metadata: null,
        id: '60fef2feea7297001be8c5f3',
      },
      {
        relatedArticles: ['60fef2feea7297001be8c5f3', '62cd8d63df69b2001b4a9b5c'],
        categories: [
          '62a76933e9dde5001b3c6b15',
          '60d1fe825749bf001bbb11e4',
          '62de67ecb31a7a001bba2d60',
        ],
        _id: '62cda1d7df69b2001b4a9c2a',
        published_at: '2022-07-12T16:36:03.404Z',
        slug: '911-assistant-rama-ix-porsche-service',
        shortDescription:
          'คุณลูกค้าได้ติดต่อให้ช่างอุ่นใจเข้ามาตรวจสอบปัญหาชักโครกมีกลิ่นเเละน้ำรั่วซึม ซึ่งช่างอุ่นใจได้รับโจทย์ในงานซ่อมแบ่งเป็น 2 ส่วนได้แก่ การซ่อมโถชักโครกและโถปัสสาวะชาย\n#งานเปลี่ยนสุขภัณฑ์ #รีวิว #กลิ่นโถส้วม',
        views: 244,
        title: 'รีวิวผลงานจริง @911 ASSISTANT RAMA IX (Porsche Service)',
        contents: [
          {
            __component: 'article.content',
            id: '62cda1d7df69b2001b4a9c2b',
          },
          {
            __component: 'article.content',
            id: '62cda1d7df69b2001b4a9c2c',
          },
        ],
        link: null,
        createdAt: '2022-07-12T16:31:19.223Z',
        updatedAt: '2022-07-25T10:08:01.825Z',
        __v: 1,
        coverImage: {
          _id: '62cd994fdf69b2001b4a9bbe',
          name: '144302486_851532738754884_6271739837459506095_n (Small).jpg',
          alternativeText: '',
          caption: '',
          hash: '144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
          ext: '.jpg',
          mime: 'image/jpeg',
          size: 75.25,
          width: 720,
          height: 480,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
          formats: {
            thumbnail: {
              name: 'thumbnail_144302486_851532738754884_6271739837459506095_n (Small).jpg',
              hash: 'thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 11.42,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            },
            small: {
              name: 'small_144302486_851532738754884_6271739837459506095_n (Small).jpg',
              hash: 'small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f',
              ext: '.jpg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 40.06,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_144302486_851532738754884_6271739837459506095_n_Small_efc7f1153f.jpg',
            },
          },
          provider: 'aws-s3',
          related: ['62cda1d7df69b2001b4a9c2a'],
          createdAt: '2022-07-12T15:54:55.834Z',
          updatedAt: '2022-07-12T16:31:19.369Z',
          __v: 0,
          id: '62cd994fdf69b2001b4a9bbe',
        },
        metadata: null,
        id: '62cda1d7df69b2001b4a9c2a',
      },
      {
        relatedArticles: ['60fef2feea7297001be8c5f3'],
        categories: ['60d1fe825749bf001bbb11e4', '62a76933e9dde5001b3c6b15'],
        _id: '60fef555ea7297001be8c617',
        published_at: '2021-07-26T17:58:58.311Z',
        slug: 'ac-with-installation',
        shortDescription:
          '#ซื้อแอร์วันนี้แถมฟรีติดตั้ง\n\n☀ ถ้าจะบอกว่าเมืองไทย ‘อากาศร้อน’ เฉพาะในช่วงหน้าร้อนก็คงจะไม่ถูก เพราะไม่ว่าฤดูไหนๆ จะร้อน หนาว ฝน อากาศก็ร้อนอยู่ดี!\nวันนี้มาดับร้อนกันดีกว่า ❄ ด้วยบริการซื้อแอร์พร้อมติดตั้งฟรี โดยทีมช่างมืออาชีพ 24 FIX 😊',
        title: 'บริการซื้อแอร์พร้อมติดตั้ง',
        contents: [
          {
            __component: 'article.content',
            id: '60fef7daea7297001be8c649',
          },
          {
            __component: 'article.images',
            id: '60fef7daea7297001be8c64a',
          },
        ],
        link: null,
        createdAt: '2021-07-26T17:48:05.531Z',
        updatedAt: '2022-07-13T05:50:55.237Z',
        __v: 0,
        views: 1124,
        coverImage: {
          _id: '60fef76eea7297001be8c634',
          name: '117956473_738009603440532_2359157732673622296_n.jpeg',
          alternativeText: '',
          caption: '',
          hash: '117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
          ext: '.jpeg',
          mime: 'image/jpeg',
          size: 253.58,
          width: 1801,
          height: 1201,
          url: 'https://d2jl6hozakvcbj.cloudfront.net/117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
          formats: {
            thumbnail: {
              name: 'thumbnail_117956473_738009603440532_2359157732673622296_n.jpeg',
              hash: 'thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 234,
              height: 156,
              size: 8.33,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/thumbnail_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            },
            large: {
              name: 'large_117956473_738009603440532_2359157732673622296_n.jpeg',
              hash: 'large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 1000,
              height: 667,
              size: 83.31,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/large_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            },
            medium: {
              name: 'medium_117956473_738009603440532_2359157732673622296_n.jpeg',
              hash: 'medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 750,
              height: 500,
              size: 50.16,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/medium_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            },
            small: {
              name: 'small_117956473_738009603440532_2359157732673622296_n.jpeg',
              hash: 'small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3',
              ext: '.jpeg',
              mime: 'image/jpeg',
              width: 500,
              height: 333,
              size: 26.25,
              path: null,
              url: 'https://d2jl6hozakvcbj.cloudfront.net/small_117956473_738009603440532_2359157732673622296_n_673d4e6ab3.jpeg',
            },
          },
          provider: 'aws-s3',
          related: ['60fef555ea7297001be8c617'],
          createdAt: '2021-07-26T17:57:02.195Z',
          updatedAt: '2021-07-30T03:43:47.943Z',
          __v: 0,
          id: '60fef76eea7297001be8c634',
        },
        metadata: null,
        id: '60fef555ea7297001be8c617',
      },
    ],
    _id: '60813de58433ab11ac597a56',
    title: 'ผลงานที่ผ่านมา',
    link: {
      newTab: true,
      _id: '60813de58433ab11ac597a57',
      text: 'ดูผลงานทั้งหมด',
      url: '/articles?slugSelect=review',
      __v: 0,
      id: '60813de58433ab11ac597a57',
    },
    __v: 1,
    icon: '60e7ebe275c7ab001bb5ef22',
    id: '60813de58433ab11ac597a56',
  },
  packageSection: [
    {
      _id: '633d3cad5abbcb001c862c22',
      kind: 'ComponentHomeSectionsHomePackage',
      ref: '60813eb48433ab11ac597a6e',
    },
  ],
  id: '608128dd83ec4517981c66dc',
}
